// import './axios.interceptor.js';
import axios from "axios";
import api_url from "./api_url";

export default class LicenseService {
  constructor(base_url) {
    if (base_url) {
      this.base_url = base_url;
    } else {
      this.base_url = api_url;
    }
  }

  async getLicenseList(token, search, page, take) {
    let str = "";

    if (search && Object.keys(search).length > 0) {
      str = Object.keys(search)
        .map((key) => {
          return `${key}=${search[key]}`;
        })
        .join("&");
    }

    const p = page ? page : 1;
    const t = take ? take : 10;

    const response = await axios.get(
      `${this.base_url}/v1/license?${str}&p=${p}&pp=${t}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  async filterLicenceList(
    token,
    empresa,
    contribuinte,
    cliente,
    software,
    serial,
    state,
    page,
    take,
  ) {
    const conditions = {};
    if (empresa) {
      conditions.empresa = empresa;
    }
    if (contribuinte) {
      conditions.contribuinte = contribuinte;
    }
    if (cliente) {
      conditions.cliente = cliente;
    }
    if (software != -1) {
      conditions.software = software;
    }
    if (serial) {
      conditions.serial = serial;
    }
    if (state != -1) {
      conditions.ativo = state;
    }

    const response = await axios.post(
      `${this.base_url}/licenses/filter?page=${page}&take=${take}`,
      {
        conditions: conditions,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  async getLicenseList2(token, search = "", page, take) {
    const response = await axios.post(
      `${this.base_url}/licenses/search?page=${page}&take=${take}`,
      {
        conditions: {
          str: search,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async orderLicense(token, license) {
    const response = await axios.post(`${this.base_url}/v1/license`, license, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  async orderLicenseV2(token, license) {
    const response = await axios.post(`${this.base_url}/v2/license`, license, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  async getSerialEmail(token, serial) {
    const response = await axios.get(
      `${this.base_url}/v1/license/serial-email/${encodeURIComponent(serial)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async updateSerialEmail(token, serial, email) {
    const response = await axios.put(
      `${this.base_url}/v1/license/serial-email/${encodeURIComponent(serial)}`,
      { email },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async validateEmail(token, email) {
    const response = await axios.get(
      `${this.base_url}/v1/validate/email?email=${encodeURIComponent(email)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  async getExpiringLicenceList(token) {
    const response = await axios.get(`${this.base_url}/v1/license/expiring`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  async getPendingLicenceList(token) {
    const response = await axios.get(`${this.base_url}/v1/license/pending`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  //disableLicense
  async disableLicense(token, id) {
    const response = await axios.put(
      `${this.base_url}/v1/license/disable/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  //enableLicense
  async enableLicense(token, id) {
    const response = await axios.put(
      `${this.base_url}/v1/license/enable/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async getInactiveLicenceList(token) {
    const response = await axios.get(`${this.base_url}/v1/license/inactive`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }

  async getLicenseFile(token, data, renew = false) {
    axios({
      url: `${this.base_url}/v1/license/file/${renew}`, //your url
      method: "POST",
      responseType: "blob", // important
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      const filename = data.descricao + ".aut";
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
  }

  async renewLicense(token, data) {
    const response = await axios.post(
      `${this.base_url}/v1/license/renew`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async renewZSFACTLicense(token, data) {
    const response = await axios.post(
      `${this.base_url}/v1/license/renew_zsfact`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async checkNif(token, nif, country = null) {
    let url = `${this.base_url}/v1/store/nif/${nif}`;
    if (country) {
      url = `${this.base_url}/v1/store/nif/${nif}/${country}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }

  async checkPartnerDemoLicense(token, contribuinte) {
    const response = await axios.get(
      `${this.base_url}/v1/license/check-partner-demo`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { contribuinte },
      },
    );
    return response.data;
  }

  async checkForExistingLicense(token, software_id, nif) {
    const response = await axios.get(
      `${this.base_url}/v1/license/persoft/${software_id}/${nif}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async getExportFile(token, data) {
    const software =
      data.software && data.software != -1 ? "&software=" + data.software : "";
    let order = data.order
      ? "&sort_" + data.order + "=DESC"
      : "&sort_nome=DESC";
    const includePostos = data.includePostos ? "&include_postos=true" : "";
    const format = data.format === "xlsx" ? "xlsx" : "csv";
    const ext = format === "xlsx" ? "xlsx" : "csv";

    axios({
      //sc=AND&software=13&lic_active=1&sort_dataemissao=DESC&p=1&pp=10
      url: `${this.base_url}/v1/license/export/${format}?sc=AND${software}&lic_active=1${order}${includePostos}&p=1&pp=20000`, //your url
      method: "GET",
      responseType: "blob", // important
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      // create a striung based on todays date ikn the format dd-mm-yyyy_hh-mm-ss
      const date = new Date();
      const filename =
        "license_export_" +
        date.getDate() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getFullYear() +
        "_" +
        date.getHours() +
        "-" +
        date.getMinutes() +
        "-" +
        date.getSeconds() +
        "." +
        ext;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
  }

  async getZSGOLicenceData(token, serial) {
    let url = `${api_url}/v1/license/zsgo/${serial}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }

  async orderZSGOLicenseChange(token, data) {
    const response = await axios.post(
      `${this.base_url}/v1/license/zsgo`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async createTag(token, tag) {
    const payload = tag;

    const response = await axios.post(`${this.base_url}/v1/tags`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async deleteTag(token, tagID) {
    const response = await axios.delete(`${this.base_url}/v1/tags/${tagID}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async updateTag(token, tagData) {
    //tagData = {tagID, tagName}
    const response = await axios.put(`${this.base_url}/v1/tags`, tagData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async getAllPartnerTags(token) {
    const response = await axios.get(`${this.base_url}/v1/partner-tags`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }

  async addTagToLicense(token, licenseID, tagID) {
    const response = await axios.post(
      `${this.base_url}/v1/licenses/${licenseID}/tags/${tagID}`,
      {},
      {
        // Empty object as body
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  }

  async removeTagFromLicense(token, licenseID, tagID) {
    const response = await axios.delete(
      `${this.base_url}/v1/licenses/${licenseID}/tags/${tagID}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  }

  async addTagToLicenses(token, licenseIDs, tagID) {
    const response = await axios.post(
      `${this.base_url}/v1/licenses/tags`,
      {
        license_ids: licenseIDs,
        tag_id: tagID,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  }

  async getAllLicenseTags(token, licenseID) {
    const response = await axios.get(
      `${this.base_url}/v1/licenses/${licenseID}/tags`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  }
  //get all licences for tag
  async getAllLicensesForTag(token, tagID) {
    const response = await axios.get(
      `${this.base_url}/v1/tags/${tagID}/licenses`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  }

  async getLicenseOrderStatus(token, filters = [], page = 1, per_page = 10) {
    const params = new URLSearchParams();
    // params.append('sc',"AND");
    params.append("p", page);
    params.append("pp", per_page);

    if (filters && Array.isArray(filters)) {
      filters.forEach((filter) => {
        Object.keys(filter).forEach((key) => {
          params.append(key, filter[key]);
        });
      });
    }

    const response = await axios.get(
      `${this.base_url}/v1/license/order-status?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async getTransactionsByOrderId(token, orderId) {
    const response = await axios.get(
      `${this.base_url}/v1/transaction/order/${orderId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async getTransactionsByTraceId(token, traceId) {
    const response = await axios.get(
      `${this.base_url}/v1/transaction/trace/${traceId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async getLocalLicensesExportFile(token, filters = {}, format = 'csv') {
    const fmt = format === 'xlsx' ? 'xlsx' : 'csv';
    const ext = fmt === 'xlsx' ? 'xlsx' : 'csv';
    const params = new URLSearchParams({ ...filters });
    const url = `${this.base_url}/v1/license/offline/export/${fmt}?${params.toString()}`;

    axios({
      url,
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      const href = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = href;
      const date = new Date();
      const filename =
        'local_license_export_' +
        date.getDate() +
        '-' +
        (date.getMonth() + 1) +
        '-' +
        date.getFullYear() +
        '_' +
        date.getHours() +
        '-' +
        date.getMinutes() +
        '-' +
        date.getSeconds() +
        '.' +
        ext;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
  }

  async getLocalLicenses(token, page = 1, perPage = 10, filters = {}) {
    const params = new URLSearchParams({
      p: page,
      pp: perPage,
      ...filters,
    });

    const response = await axios.get(
      `${this.base_url}/v1/license/offline?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  async getPartnerCredits(token, partnerId, softwareId, licenseType) {
    const response = await axios.get(
      `${this.base_url}/v1/credits/partner/${partnerId}/software/${softwareId}/license/${licenseType}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async getExpiredLicenses(token, page = 1, perPage = 10, filters = {}) {
    let fObj = {
      p: page,
      pp: perPage,
      ...filters,
      // datalimite_lt:'NOW()'
    };

    if (filters?.global) {
      delete filters.global;
      fObj = {
        p: page,
        pp: perPage,
        ...filters,
      };
    }

    const params = new URLSearchParams(fObj);

    const response = await axios.get(
      `${this.base_url}/v1/license/expiring?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  async getAboutToExpireLicenses(token, page = 1, perPage = 10, filters = {}) {
    const params = new URLSearchParams({
      p: page,
      pp: perPage,
      ...filters,
      // datalimite_gt:'NOW()'
    });

    const response = await axios.get(
      `${this.base_url}/v1/license/about-to-expire?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  async getPendingLicensesWithFilters(
    token,
    page = 1,
    perPage = 10,
    filters = {},
  ) {
    const params = new URLSearchParams({
      p: page,
      pp: perPage,
      ...filters,
    });

    const response = await axios.get(
      `${this.base_url}/v1/license/pending?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  // Hardware Request Status Methods
  async getHardwareRequestStatusList(
    token,
    page = 1,
    per_page = 10,
    filters = {},
    sort = null,
  ) {
    const params = new URLSearchParams({
      p: page,
      pp: per_page,
      ...filters,
    });

    // Add filters
    // if (filters && Array.isArray(filters)) {
    //   filters.forEach(filter => {
    //     Object.keys(filter).forEach(key => {
    //       params.append('filter', `${key}=${filter[key]}`);
    //     });
    //   });
    // }

    // Add sorting
    // if (sort) {
    //   params.append('sort', sort);
    // }

    const response = await axios.get(
      `${this.base_url}/v1/hardware-requests?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  async updateHardwareRequestStatus(token, id, status, data = null) {
    const body = { status };
    if (data) {
      body.data = typeof data === "string" ? data : JSON.stringify(data);
    }

    const response = await axios.put(
      `${this.base_url}/v1/hardware-requests/${id}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  /**
   * Searches for partners based on various criteria.
   * This function sends a GET request to the '/v1/auth/search-partners' endpoint.
   *
   * @param {string} token - The JWT authentication token for the logged-in user.
   * @param {object} searchParams - Object containing search parameters:
   *   - id: Partner ID (exact match)
   *   - name: Partner name (partial match)
   *   - nif: Partner NIF (exact match)
   *   - limit: Number of results per page (default: 50)
   *   - offset: Number of results to skip (default: 0)
   * @returns {Promise<object>} A promise that resolves to the API response data containing partners array and pagination info.
   * @throws {Error} Throws an error if the API call fails.
   */
  async searchPartners(token, searchParams = {}) {
    const params = new URLSearchParams();

    // Add search parameters if provided
    if (searchParams.id) {
      params.append("id", searchParams.id);
    }
    if (searchParams.name) {
      params.append("name", searchParams.name);
    }
    if (searchParams.nif) {
      params.append("nif", searchParams.nif);
    }
    if (searchParams.limit) {
      params.append("limit", searchParams.limit);
    } else {
      params.append("limit", "50"); // Default limit
    }
    if (searchParams.offset) {
      params.append("offset", searchParams.offset);
    } else {
      params.append("offset", "0"); // Default offset
    }

    const response = await axios.get(
      `${this.base_url}/v1/auth/search-partners?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  /**
   * Refunds a specified amount of credits to a partner's account.
   * This function sends a POST request to the '/v1/credits_refund' endpoint.
   *
   * @param {string} token - The JWT authentication token for the logged-in user.
   * @param { string} order_id - Order id to get Transaction id
   * @param {number} partnerId - The unique identifier of the partner who will receive the credit refund.
   * @param {number} amount - The positive integer amount of credits to be refunded.
   * @param {string} reason - A descriptive reason for the refund, which will be logged for auditing purposes.
   * @returns {Promise<object>} A promise that resolves to the API response data (e.g., { status: "ok", message: "..." }).
   * @throws {Error} Throws an error if the API call fails.
   */
  async refundCredits(token, order_id, partnerId, amount, reason) {
    // Construct the request body. The keys must match the JSON tags
    // expected by the backend Go struct (partner_id, amount, reason).
    const body = {
      order_id: order_id,
      partner_id: partnerId,
      amount: amount,
      reason: reason,
    };

    // Make the POST request to the new endpoint using axios.
    const response = await axios.post(
      `${this.base_url}/v1/credits_refund`,
      body,
      {
        headers: {
          // Set the authorization header with the Bearer token.
          Authorization: `Bearer ${token}`,
        },
      },
    );

    // Return the data part of the response from the API.
    return response.data;
  }

  async getCancellationDate(token, serial) {
    const response = await axios.get(
      `${this.base_url}/v1/license/cancel/${serial}/date`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }

  async cancelLicense(token, stores, serial, cloudkeeper, userId) {
    const payload = {
      stores: stores,
      serial: serial,
		cloudkeeper: cloudkeeper,
      user_id: userId,
    };

    const response = await axios.post(
      `${this.base_url}/v1/store/cancel`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  }
}
